import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  id: "Rectangle_2855",
  "data-name": "Rectangle 2855",
  width: "16",
  height: "16",
  fill: "none"
}, null, -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'IconCheck',
  props: {
    classStroke: {},
    size: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    id: "Icon_feather-check",
    "data-name": "Icon feather-check",
    xmlns: "http://www.w3.org/2000/svg",
    height: _ctx.size || 16,
    viewBox: "0 0 16 16"
  }, [
    _hoisted_2,
    _createElementVNode("path", {
      id: "Icon_feather-check-2",
      class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
      "data-name": "Icon feather-check",
      d: "M16.439,9,9.262,16.177,6,12.915",
      transform: "translate(-3.219 -4.588)",
      fill: "none",
      stroke: "#1b7ec0",
      "stroke-linejoin": "round",
      "stroke-width": "3"
    }, null, 2)
  ], 8, _hoisted_1))
}
}

})